// VAL-ADMIN-LINK-1 — the platform admin address, from the server's PLATFORM_ADMIN_URL
// setting (runtime, so one image serves DEV and QA). super_admin only; '' means no link.
import { apiClient } from '@/api/client'

export async function fetchPlatformAdminUrl(): Promise<string> {
  const { data } = await apiClient.get<{ platform_admin_url: string }>('/v1/valuation/platform-admin-url')
  return data.platform_admin_url ?? ''
}
